import * as actionTypes from './actionTypes';
import { gql } from "apollo-boost";
import * as dataSet from './dataSet';
import * as actionCreators from './index';

/**
 * TYPE : GET
 * Getting Lead List
 */
export const getLeadList = (client, value) => {

    return function (dispatch) {
        const query = gql`
                query getLeadList($list: LeadListInput!) 
                {
                    getLeadList(list: $list) {
                        totalrecord
                        totalpage
                        data
                    }
                }
            `;
        client.query({
            query: query,
            fetchPolicy: 'no-cache',
            variables: value,
        }).then(response => {
            let return_data = dataSet.processGQLData(response.data.getLeadList);
            dispatch(setResponseDetails(actionTypes.GET_LEAD_LIST, return_data));
        }).catch((error) => {
            // let err_data = errorMessageGraphQl(error);
            var returnData = {
                'data': {},
                'error': false,
                'notify_msg': ""
            }
            dispatch(setResponseDetails(actionTypes.GET_LEAD_LIST, returnData));
            //dispatch(notificationAll(actionTypes.NOTIFICATIONS, err_data));
        });
    }
}

/**
 * TYPE : GET
 * Getting Lead Filter List
 */
export const getLeadFilterList = (client, value) => {
    return function (dispatch) {
        const query = gql`
                query getLeadFilterList($filterdata: [JSON!]!,$list: LeadListInput!, $filterid: Float!)                 
                {
                    getLeadFilterList(filterdata:$filterdata, list: $list, filterid: $filterid) {
                        totalrecord
                        totalpage
                        data
                    }
                }
            `;
        client.query({
            query: query,
            fetchPolicy: 'no-cache',
            variables: value,
        }).then(response => {
            let return_data = dataSet.processGQLData(response.data.getLeadFilterList);
            dispatch(setResponseDetails(actionTypes.GET_LEAD_FILTER_LIST, return_data));
        }).catch((error) => {
            //let err_data = errorMessageGraphQl(error);
            var returnData = {
                'data': {},
                'error': false,
                'notify_msg': ""
            }
            dispatch(setResponseDetails(actionTypes.GET_LEAD_LIST, returnData));
            //dispatch(notificationAll(actionTypes.NOTIFICATIONS, err_data));
        });
    }
}

export const deleteLead = (client, request) => {
    return dispatch => {
        const query = gql`
            query deleteLead($leadid: [Float!]!)                 
            {
                deleteLead(leadid:$leadid) {
                    status
                    message
                }
            }
        `;
        client.query({
            query: query,
            variables: request['deleteid'],
        }).then(response => {
            let returnData = [];
            if (response.data && response.data != undefined) {
                if (response.data.deleteLead.status == "true") {
                    returnData = {
                        'data': {},
                        'error': false,
                        'notify_msg': response.data.deleteLead.message
                    }
                    dispatch(notificationAll(actionTypes.NOTIFICATIONS, returnData, true));
                } else {
                    returnData = {
                        'data': {},
                        'error': true,
                        'notify_msg': response.data.deleteLead.message
                    }
                    dispatch(notificationAll(actionTypes.NOTIFICATIONS, returnData, false));
                }
            }
            dispatch(actionCreators.getLeadFilterList(client, request['listval']))
        }).catch((error) => {
            let err_data = errorMessageGraphQl(error);
            dispatch(notificationAll(actionTypes.NOTIFICATIONS, err_data));
        });
    }
}

export const addFavouriteLead = (client, request) => {
    return dispatch => {
        const mutation = gql`
             mutation addFavouriteLead($status:Boolean!, $leadid:Float!) {
                 addFavouriteLead(status:$status,leadid:$leadid) {
                    status
                    message
                 }
               }
             `;
        client.mutate({
            mutation: mutation,
            variables: request['favorite']
        })
            .then(response => {
                let returnData = [];
                if (response.data && response.data != undefined) {
                    if (response.data.addFavouriteLead.status == "true") {
                        // returnData = {
                        //     'data': {},
                        //     'error': false,
                        //     'notify_msg': response.data.addFavouriteLead.message
                        // }
                        // dispatch(notificationAll(actionTypes.NOTIFICATIONS, returnData, true));
                        dispatch(actionCreators.getLeadFilterList(client, request['listval']))
                        dispatch(actionCreators.getLeadField(client, request['favorite'].leadid))
                    } else {
                        returnData = {
                            'data': {},
                            'error': true,
                            'notify_msg': response.data.addFavouriteLead.message
                        }
                        dispatch(notificationAll(actionTypes.NOTIFICATIONS, returnData, false));
                    }
                }
                
            }).catch((error) => {
                let err_data = errorMessageGraphQl(error);
                dispatch(notificationAll(actionTypes.NOTIFICATIONS, err_data));
            });
    }
}
export const updateLeadListColumnOrder = (client,request) => { 
    return dispatch => {
        const mutation = gql`
             mutation updateLeadListColumnOrder($orderno:[Float!]!, $columnstatus:[Boolean!]!,$fieldid:[Float!]!) {
                 updateLeadListColumnOrder(orderno:$orderno,columnstatus:$columnstatus,fieldid:$fieldid) {
                    status
                    message
                 }
               }
             `;
        client.mutate({
            mutation: mutation,
            variables: request
        })
        .then(response => {
            let returnData = [];
            if (response.data && response.data != undefined) {
                if (response.data.updateLeadListColumnOrder.status == "true") {
                    returnData = {
                        'data': {},
                        'error': false,
                        'notify_msg': response.data.updateLeadListColumnOrder.message
                    }
                    dispatch(notificationAll(actionTypes.NOTIFICATIONS, returnData, true)); 
                    dispatch(actionCreators.getLeadListColumnOrder(client))                       
                } else {
                    returnData = {
                        'data': {},
                        'error': true,
                        'notify_msg': response.data.updateLeadListColumnOrder.message
                    }
                    dispatch(notificationAll(actionTypes.NOTIFICATIONS, returnData, false));
                }
            }
            
                
        }).catch((error) => {
            let err_data = errorMessageGraphQl(error);
            dispatch(notificationAll(actionTypes.NOTIFICATIONS, err_data));
        });
    }
}
export const getLeadListColumnOrder = (client) => {
    return function (dispatch) {
        const query = gql`
                query getLeadListColumnOrder
                {
                    getLeadListColumnOrder {
                        id
                        field{
                            id
                            fieldkey
                            fieldlabel
                        }
                        userid
                        columnid
                        orderno
                        isactive
                    }
                }
            `;
        client.query({
            query: query,
            fetchPolicy: 'no-cache',
        }).then(response => {


            let return_data = dataSet.processGQLData(response.data.getLeadListColumnOrder);
            dispatch(setResponseDetails(actionTypes.GET_LEAD_LIST_ORDER, return_data));
        }).catch((error) => {
            //let err_data = errorMessageGraphQl(error);
            var returnData = {
                'data': {},
                'error': false,
                'notify_msg': ""
            }
            dispatch(setResponseDetails(actionTypes.GET_LEAD_LIST_ORDER, returnData));
            //dispatch(notificationAll(actionTypes.NOTIFICATIONS, err_data));
        });
    }
}




/**
 * [addLeadLogComment saves comments of log]
 */
export const addLeadLogComment = (client, request) => {
    return dispatch => {
        const mutation = gql`
             mutation addLeadLogComment($logid:Float!, $comment:String!,$type:String!) {
                 addLeadLogComment(logid:$logid, comment:$comment, type:$type) {
                    status
                    message
                 }
               }
             `;
        client.mutate({
            mutation: mutation,
            variables: { logid: request.logid, comment: request.comment, type: request.type }
        })
            .then(response => {
                let returnData = [];
                if (response.data && response.data != undefined) {
                    if (response.data.addLeadLogComment.status == "true") {
                        returnData = {
                            'data': {},
                            'error': false,
                            'notify_msg': response.data.addLeadLogComment.message
                        }
                        dispatch(notificationAll(actionTypes.NOTIFICATIONS, returnData, true));
                        
                        let logparam = { leadid: request.leadid, emailid: request.emailid, logtypeid: request.logtypeid, activitypeid: request.activitypeid };
                        dispatch(actionCreators.getLeadActivityLogList(client, logparam))
                        dispatch(actionCreators.getLeadLogListNew(client, logparam))
                        dispatch(actionCreators.getLeadField(client, request.leadid))
                    } else {
                        returnData = {
                            'data': {},
                            'error': true,
                            'notify_msg': response.data.addLeadLogComment.message
                        }
                        dispatch(notificationAll(actionTypes.NOTIFICATIONS, returnData, false));
                    }
                }
            }).catch((error) => {
                let err_data = errorMessageGraphQl(error);
                dispatch(notificationAll(actionTypes.NOTIFICATIONS, err_data));
            });
    }
}

/**
 * [updateLeadLogComment saves comments of log]
 */
export const updateLeadLogComment = (client, request) => {
    return dispatch => {
        const mutation = gql`
             mutation updateLeadLogComment($commentid:Float!, $comment:String!,$type:String!) {
                 updateLeadLogComment(commentid:$commentid, comment:$comment, type:$type) {
                    status
                    message
                 }
               }
             `;
        client.mutate({
            mutation: mutation,
            variables: { commentid: request.commentid, comment: request.comment, type: request.type }
        })
            .then(response => {
                let returnData = [];
                if (response.data && response.data != undefined) {
                    if (response.data.updateLeadLogComment.status == "true") {
                        returnData = {
                            'data': {},
                            'error': false,
                            'notify_msg': response.data.updateLeadLogComment.message
                        }
                        dispatch(notificationAll(actionTypes.NOTIFICATIONS, returnData, true));

                        let logparam = { leadid: request.leadid, emailid: request.emailid, logtypeid: request.logtypeid, activitypeid: request.activitypeid };
                        dispatch(actionCreators.getLeadActivityLogList(client, logparam))
                        dispatch(actionCreators.getLeadLogListNew(client, logparam))
                        dispatch(actionCreators.getLeadField(client, request.leadid))
                    } else {
                        returnData = {
                            'data': {},
                            'error': true,
                            'notify_msg': response.data.updateLeadLogComment.message
                        }
                        dispatch(notificationAll(actionTypes.NOTIFICATIONS, returnData, false));
                    }
                }
            }).catch((error) => {
                let err_data = errorMessageGraphQl(error);
                dispatch(notificationAll(actionTypes.NOTIFICATIONS, err_data));
            });
    }
}
export const deleteLeadLogComment = (client, request) => {

    return dispatch => {
        const query = gql`
            query deleteLeadLogComment($commentid: Float!, $type: String!)                 
            {
                deleteLeadLogComment(commentid:$commentid, type:$type) {
                    status
                    message
                }
            }
        `;
        client.query({
            query: query,
            variables: { commentid: request.commentid, type: request.type },
        }).then(response => {
            let returnData = [];
            if (response.data && response.data != undefined) {
                if (response.data.deleteLeadLogComment.status == "true") {
                    returnData = {
                        'data': {},
                        'error': false,
                        'notify_msg': response.data.deleteLeadLogComment.message
                    }

                    dispatch(notificationAll(actionTypes.NOTIFICATIONS, returnData, true));
                    let logparam = { leadid: request.leadid, emailid: request.emailid, logtypeid: request.logtypeid, activitypeid: request.activitypeid };
                    dispatch(actionCreators.getLeadActivityLogList(client, logparam))
                    dispatch(actionCreators.getLeadLogListNew(client, logparam))
                    dispatch(actionCreators.getLeadField(client, request.leadid))
                } else {
                    returnData = {
                        'data': {},
                        'error': true,
                        'notify_msg': response.data.deleteLeadLogComment.message
                    }
                    dispatch(notificationAll(actionTypes.NOTIFICATIONS, returnData, false));
                }
            }
        }).catch((error) => {
            let err_data = errorMessageGraphQl(error);
            dispatch(notificationAll(actionTypes.NOTIFICATIONS, err_data));
        });
    }
}


/**
 * TYPE : GET
 * Getting Lead Log List with filter
 */
export const getLeadLogListNew = (client, request) => {

    let paramtype = request.logtypeid;
    let pullarr = [1000, 1001];
    pullarr.map((arr) => {
        if (paramtype.indexOf(arr) != -1) {
            let ind = paramtype.indexOf(arr);
            paramtype.splice(ind, 1);
        }
    });
    
    return function (dispatch) {
        const query = gql`
                query getLeadLogListNew($leadid: Float!, $emailid: String!, $logtypeid:[Float!], $activitypeid:[Float!])                 
                {
                    getLeadLogListNew(leadid: $leadid,emailid:$emailid,logtypeid:$logtypeid,activitypeid:$activitypeid) {
                        logdata
                        status
                        message
                    }
                }
            `;
        client.query({
            query: query,
            fetchPolicy: 'no-cache',
            variables: { leadid: request.leadid, emailid: request.emailid, logtypeid: paramtype, activitypeid: request.activitypeid },
        }).then(response => {
            let return_data = dataSet.processGQLData(response.data.getLeadLogListNew);
            dispatch(setResponseDetails(actionTypes.GET_LEAD_LOG_LIST, return_data));
        }).catch((error) => {
            //let err_data = errorMessageGraphQl(error);
            var returnData = {
                'data': {},
                'error': false,
                'notify_msg': ""
            }
            dispatch(setResponseDetails(actionTypes.GET_LEAD_LOG_LIST, returnData));
            //dispatch(notificationAll(actionTypes.NOTIFICATIONS, err_data));
        });
    }
}

/**
 * TYPE : GET
 * Getting Lead Log List with filter
 */
export const getLeadActivityLogList = (client, request) => {
    return function (dispatch) {
        const query = gql`
                query getLeadActivityLogList($leadid: Float!, $emailid: String!, $logtypeid:[Float!], $activitypeid:[Float!])                 
                {
                    getLeadActivityLogList(leadid: $leadid,emailid:$emailid,logtypeid:$logtypeid,activitypeid:$activitypeid) {
                        status
                        message
                        pined
                        today
                        yesterday
                        thisweek
                        lastweek
                        thismonth
                        lastmonth
                        earlier
                    }
                }
            `;
        client.query({
            query: query,
            fetchPolicy: 'no-cache',
            variables: request,
        }).then(response => {
            let return_data = dataSet.processGQLData(response.data.getLeadActivityLogList);
            dispatch(setResponseDetails(actionTypes.GET_LEAD_LOG_SIDEBAR_LIST, return_data));
        }).catch((error) => {
            //let err_data = errorMessageGraphQl(error);
            var returnData = {
                'data': {},
                'error': false,
                'notify_msg': ""
            }
            dispatch(setResponseDetails(actionTypes.GET_LEAD_LOG_LIST, returnData));
            //dispatch(notificationAll(actionTypes.NOTIFICATIONS, err_data));
        });
    }
}


/**
 * TYPE : GET
 * Getting Lead Log List
 */
export const getLeadLogList = (client, request) => {
    return function (dispatch) {
        const query = gql`
                query getLeadLogList($leadid: Float!, $emailid: String!)                 
                {
                    getLeadLogList(leadid: $leadid,emailid:$emailid) {
                        logdata
                        status
                        message
                    }
                }
            `;
        client.query({
            query: query,
            fetchPolicy: 'no-cache',
            variables: request,
        }).then(response => {
            let return_data = dataSet.processGQLData(response.data.getLeadLogList);
            dispatch(setResponseDetails(actionTypes.GET_LEAD_LOG_LIST, return_data));
        }).catch((error) => {
            //let err_data = errorMessageGraphQl(error);
            var returnData = {
                'data': {},
                'error': false,
                'notify_msg': ""
            }
            dispatch(setResponseDetails(actionTypes.GET_LEAD_LOG_LIST, returnData));
            //dispatch(notificationAll(actionTypes.NOTIFICATIONS, err_data));
        });
    }
}

export const saveLeadLog = (client, request) => {
    return dispatch => {
        const mutation = gql`
             mutation saveLeadLog($propertyname:String!, $propertyid:Float!, $leadid:Float!, $text:String!, $oldvalue:String!, $newvalue:String!, $logtime:Float!, $logdate:Float!, $logtype:Float!, $fieldid:Float!) {
                 saveLeadLog(propertyname:$propertyname, propertyid:$propertyid, leadid:$leadid, text:$text, oldvalue:$oldvalue, newvalue:$newvalue, logtype:$logtype, logtime:$logtime, logdate:$logdate, fieldid:$fieldid) {
                    status
                    message
                 }
               }
             `;
        client.mutate({
            mutation: mutation,
            variables: request['save']
        })
        .then(response => {
            let returnData = [];
            if (response.data && response.data != undefined) {
                if (response.data.saveLeadLog.status == "true") {
                    returnData = {
                        'data': {},
                        'error': false,
                        'notify_msg': response.data.saveLeadLog.message
                    }
                    dispatch(notificationAll(actionTypes.NOTIFICATIONS, returnData, true));
                    dispatch(actionCreators.getLeadActivityLogList(client, request['getlog']))
                    dispatch(actionCreators.getLeadLogListNew(client, request['getlog']))
                    dispatch(actionCreators.getLeadField(client, request['getlog'].leadid))
                    
                    
                } else {
                    returnData = {
                        'data': {},
                        'error': true,
                        'notify_msg': response.data.saveLeadLog.message
                    }
                    dispatch(notificationAll(actionTypes.NOTIFICATIONS, returnData, false));
                }
            }
        }).catch((error) => {
            let err_data = errorMessageGraphQl(error);
            dispatch(notificationAll(actionTypes.NOTIFICATIONS, err_data));
        });
    }
}

export const updateLeadLog = (client, request) => {
    return dispatch => {
        const mutation = gql`
             mutation updateLeadLog($text:String!, $logtime:Float!, $logdate:Float!, $logid:Float!) {
                 updateLeadLog(text:$text, logtime:$logtime, logdate:$logdate, logid:$logid) {
                    status
                    message
                 }
               }
             `;
        client.mutate({
            mutation: mutation,
            variables: request['update']
        })
            .then(response => {
                let returnData = [];
                if (response.data && response.data != undefined) {
                    if (response.data.updateLeadLog.status == "true") {
                        returnData = {
                            'data': {},
                            'error': false,
                            'notify_msg': response.data.updateLeadLog.message
                        }
                        dispatch(notificationAll(actionTypes.NOTIFICATIONS, returnData, true));
                        dispatch(actionCreators.getLeadActivityLogList(client, request['getlog']))
                        dispatch(actionCreators.getLeadLogListNew(client, request['getlog']))
                        dispatch(actionCreators.getLeadField(client, request['getlog'].leadid))


                    } else {
                        returnData = {
                            'data': {},
                            'error': true,
                            'notify_msg': response.data.updateLeadLog.message
                        }
                        dispatch(notificationAll(actionTypes.NOTIFICATIONS, returnData, false));
                    }
                }
            }).catch((error) => {
                let err_data = errorMessageGraphQl(error);
                dispatch(notificationAll(actionTypes.NOTIFICATIONS, err_data));
            });
    }
}
export const deleteLeadLogDetail = (client, request) => {
    
    return dispatch => {
        const query = gql`
            query deleteLeadLogDetail($logid: Float!)                 
            {
                deleteLeadLogDetail(logid:$logid) {
                    status
                    message
                }
            }
        `;
        client.query({
            query: query,
            variables: { logid: request.logid },
        }).then(response => {
            let returnData = [];
            if (response.data && response.data != undefined) {
                if (response.data.deleteLeadLogDetail.status == "true") {
                    returnData = {
                        'data': {},
                        'error': false,
                        'notify_msg': response.data.deleteLeadLogDetail.message
                    }
                    
                    dispatch(notificationAll(actionTypes.NOTIFICATIONS, returnData, true));
                    let logparam = { leadid: request.leadid, emailid: request.emailid, logtypeid: request.logtypeid, activitypeid: request.activitypeid };
                    dispatch(actionCreators.getLeadActivityLogList(client, logparam))
                    dispatch(actionCreators.getLeadLogListNew(client, logparam))
                    dispatch(actionCreators.getLeadField(client, request.leadid))
                } else {
                    returnData = {
                        'data': {},
                        'error': true,
                        'notify_msg': response.data.deleteLeadLogDetail.message
                    }
                    dispatch(notificationAll(actionTypes.NOTIFICATIONS, returnData, false));
                }
            }
        }).catch((error) => {
            let err_data = errorMessageGraphQl(error);
            dispatch(notificationAll(actionTypes.NOTIFICATIONS, err_data));
        });
    }
}

// export const saveLeadDetail = (client, request) => {
//     return dispatch => {
//         const mutation = gql`
//              mutation saveLeadDetail($leaddata:[JSON!]!) {
//                  saveLeadDetail(leaddata:$leaddata) {
//                     status
//                     message
//                  }
//                }
//              `;
//         client.mutate({
//             mutation: mutation,
//             variables: {
//                 leaddata: request.LeadData,
//             }
//         })
//         .then(response => {
//             let returnData = [];
//             if (response.data && response.data != undefined) {
//                 if (response.data.saveLeadDetail.status == "true") {
//                     returnData = {
//                         'data': {},
//                         'error': false,
//                         'notify_msg': response.data.saveLeadDetail.message
//                     }
//                     dispatch(notificationAll(actionTypes.NOTIFICATIONS, returnData, true));
//                 } else {
//                     returnData = {
//                         'data': {},
//                         'error': true,
//                         'notify_msg': response.data.saveLeadDetail.message
//                     }
//                     dispatch(notificationAll(actionTypes.NOTIFICATIONS, returnData, false));
//                 }
//             }
//         }).catch((error) => {
//             let err_data = errorMessageGraphQl(error);
//             dispatch(notificationAll(actionTypes.NOTIFICATIONS, err_data));
//         });
//     }
// }

export const saveLeadDetail = (client, request) => {
    return dispatch => {
        const mutation = gql`
             mutation saveLeadDetail($leaddata:[JSON!]!) {
                 saveLeadDetail(leaddata:$leaddata) {
                    status
                    message
                 }
               }
             `;
        client.mutate({
            mutation: mutation,
            variables: {
                leaddata: request.LeadData,
            }
        })
            .then(response => {
                let returnData = [];
                if (response.data && response.data != undefined) {
                    if (response.data.saveLeadDetail.status == "true") {
                        returnData = {
                            'data': {},
                            'error': false,
                            'notify_msg': response.data.saveLeadDetail.message
                        }
                        dispatch(notificationAll(actionTypes.NOTIFICATIONS, returnData, true));
                    } else {
                        returnData = {
                            'data': {},
                            'error': true,
                            'notify_msg': response.data.saveLeadDetail.message
                        }
                        dispatch(notificationAll(actionTypes.NOTIFICATIONS, returnData, false));
                    }
                }
                let val = {
                    filterdata: [],
                    list: {
                        limit:10,
                        pageno: 1,
                        searchtext: "",
                        sorttype: "",
                        type: "list",
                        fieldId: 1,
                        columnname:''
                    },
                    filterid: 1
                }
                
                dispatch(actionCreators.getLeadFilterList(client,val))
            }).catch((error) => {
                let err_data = errorMessageGraphQl(error);
                dispatch(notificationAll(actionTypes.NOTIFICATIONS, err_data));
            });
    }
}

export const getLeadField = (client,leadId) => {
    return function (dispatch) {
        const query = gql`
                query getLeadField($leadId: Float!) 
                {
                    getLeadField(leadId: $leadId) {
                        id
                        is_default
                        fieldstatus
                        fieldkey
                        fieldtype{
                          id
                          name
                        }
                        fieldicon
                        fieldlabel
                        generatedfieldid
                        leaddetail{
                          id
                          values
                          fieldvalue
                          lead{
                                interactions
                                inactivedays
                                lastcontacted
                            }
                        }
                        options
                        leadfavourite
                        image
                    }
                }
            `;
        client.query({
            query: query,
            fetchPolicy: 'no-cache',
            variables: {
                leadId:leadId
            },
        }).then(response => {
            let return_data = dataSet.processGQLData(response.data.getLeadField);
            dispatch(setResponseDetails(actionTypes.LEAD_FIELD_DATA, return_data));
        }).catch((error) => {
            let err_data = errorMessageGraphQl(error);
            dispatch(notificationAll(actionTypes.NOTIFICATIONS, err_data));
        });
    }
}

export const updateLeadDetail = (client, request) => {
    return dispatch => {
        const mutation = gql`
             mutation updateLeadDetail($leaddata:[JSON!]!,$leadid:Float!,$fileInput:Upload!) {
                 updateLeadDetail(leaddata:$leaddata,leadid:$leadid,fileInput:$fileInput) {
                    status
                    message
                 }
               }
             `;
        client.mutate({
            mutation: mutation,
            variables: {
                leaddata: request.LeadData,
                leadid: request.leadid,
                fileInput: request.leadFile,
            }
        })
        .then(response => {
            let returnData = [];
            if (response.data && response.data != undefined) {
                if (response.data.updateLeadDetail.status == "true") {
                    returnData = {
                        'data': {},
                        'error': false,
                        'notify_msg': response.data.updateLeadDetail.message
                    }
                    dispatch(notificationAll(actionTypes.NOTIFICATIONS, returnData, true));
                } else {
                    returnData = {
                        'data': {},
                        'error': true,
                        'notify_msg': response.data.updateLeadDetail.message
                    }
                    dispatch(notificationAll(actionTypes.NOTIFICATIONS, returnData, false));
                }
            }
            
            let logparam = { leadid: request.leadid, emailid: '', logtypeid: [], activitypeid: [] };
            dispatch(actionCreators.getLeadLogListNew(client, logparam))
            dispatch(actionCreators.getLeadField(client,request.leadid))

            let val = {
                filterdata: [],
                list: {
                    limit: 10,
                    pageno: 1,
                    searchtext: "",
                    sorttype: "",
                    type: "list",
                    fieldId: 1,
                    columnname: ''
                },
                filterid: 1
            }

            dispatch(actionCreators.getLeadFilterList(client, val))
        }).catch((error) => {
            let err_data = errorMessageGraphQl(error);
            dispatch(notificationAll(actionTypes.NOTIFICATIONS, err_data));
        });
    }
}

export const saveFilterDetail = (client, request) => {
    return dispatch => {
        const mutation = gql`
             mutation saveFilterDetail($filterdata:[JSON!]!,$fitertype:String!,$filtername: String!,$recordtypeid: Float!) {
                 saveFilterDetail(filterdata:$filterdata,fitertype:$fitertype,filtername:$filtername,recordtypeid:$recordtypeid) {
                    id
                    fitertype
                    userid
                    filtername
                    filterquery
                    filteroption
                    isdefault
                    recordtypeid
                    isselected
                 }
               }
             `;
        client.mutate({
            mutation: mutation,
            variables: {
                filterdata: request.filterdata,
                fitertype: request.fitertype,
                filtername: request.filtername,
                recordtypeid: request.recordtypeid,
            }
        })
        .then(response => {
            let returnData = [];
            if (response.data && response.data != undefined) {
                if (response.data.saveFilterDetail.id) {
                    returnData = {
                        'data': {},
                        'error': false,
                        'notify_msg': "Filter save successfully."
                    }
                    dispatch(notificationAll(actionTypes.NOTIFICATIONS, returnData, true));
                } 
            }
            dispatch(actionCreators.getFilterList(client,1))
        }).catch((error) => {
            let err_data = errorMessageGraphQl(error);
            dispatch(notificationAll(actionTypes.NOTIFICATIONS, err_data));
        });
    }
}

export const getFilterList = (client,recordtypeid) => {
    return function (dispatch) {
        const query = gql`
                query getFilterList($recordtypeid: Float!) 
                {
                    getFilterList(recordtypeid: $recordtypeid) {
                        id
                        fitertype
                        userid
                        filtername
                        filterquery
                        filteroption
                        isdefault
                        recordtypeid
                        isselected
                    }
                }
            `;
        client.query({
            query: query,
            fetchPolicy: 'no-cache',
            variables: {
                recordtypeid:recordtypeid
            },
        }).then(response => {
            let return_data = dataSet.processGQLData(response.data.getFilterList);
            dispatch(setResponseDetails(actionTypes.GET_LEADFILTER_LIST, return_data));
        }).catch((error) => {
            //let err_data = errorMessageGraphQl(error);
            //dispatch(notificationAll(actionTypes.NOTIFICATIONS, err_data));
        });
    }
}
export const deleteFilter = (client,filterid) => {
    return function (dispatch) {
        const query = gql`
                query deleteFilter($filterid: Float!) 
                {
                    deleteFilter(filterid: $filterid) {
                        status
                        message
                    }
                }
            `;
        client.query({
            query: query,
            fetchPolicy: 'no-cache',
            variables: {
                filterid:filterid
            },
        }).then(response => {
            let returnData = [];
            if (response.data && response.data != undefined) {
                if (response.data.deleteFilter.status == "true") {
                    returnData = {
                        'data': {},
                        'error': false,
                        'notify_msg': response.data.deleteFilter.message
                    }
                    dispatch(notificationAll(actionTypes.NOTIFICATIONS, returnData, true));
                } else {
                    returnData = {
                        'data': {},
                        'error': true,
                        'notify_msg': response.data.deleteFilter.message
                    }
                    dispatch(notificationAll(actionTypes.NOTIFICATIONS, returnData, false));
                }
            }
            dispatch(actionCreators.getFilterList(client,1))
        }).catch((error) => {
            let err_data = errorMessageGraphQl(error);
            dispatch(notificationAll(actionTypes.NOTIFICATIONS, err_data));
        });
    }
}

export const updateFilterDefault = (client,filterid) => { 
    return dispatch => {
        const mutation = gql`
             mutation updateFilterDefault($type:String!, $fiterid:Float!,$recordtypeid:Float!) {
                 updateFilterDefault(type:$type,fiterid:$fiterid,recordtypeid:$recordtypeid) {
                    status
                    message
                 }
               }
             `;
        client.mutate({
            mutation: mutation,
            variables: {
                type:"isdefault",
                fiterid:filterid,
                recordtypeid:1
            },
        })
        .then(response => {
            let returnData = [];
            if (response.data && response.data != undefined) {
                if (response.data.updateFilterDefault.status == "true") {
                    returnData = {
                        'data': {},
                        'error': false,
                        'notify_msg': response.data.updateFilterDefault.message
                    }
                    dispatch(notificationAll(actionTypes.NOTIFICATIONS, returnData, true));                        
                } else {
                    returnData = {
                        'data': {},
                        'error': true,
                        'notify_msg': response.data.updateFilterDefault.message
                    }
                    dispatch(notificationAll(actionTypes.NOTIFICATIONS, returnData, false));
                }
            }
            dispatch(actionCreators.getFilterList(client,1))    
        }).catch((error) => {
            let err_data = errorMessageGraphQl(error);
            dispatch(notificationAll(actionTypes.NOTIFICATIONS, err_data));
        });
    }
}

export const updateFilterDetail = (client,request) => { 
    return dispatch => {
        const mutation = gql`
             mutation updateFilterDetail($filterdata: [JSON!]!, $fitertype:String!,$filtername:String!,$filterid:Float!) {
                 updateFilterDetail(filterdata:$filterdata,fitertype:$fitertype,filtername:$filtername,filterid:$filterid) {
                    id
                 }
               }
             `;
        client.mutate({
            mutation: mutation,
            variables: {
                filterdata  : request.filterdata,
                fitertype   : request.fitertype,
                filtername  : request.filtername,
                filterid    : request.filterid,
            }
        })
        .then(response => {
            let returnData = [];
            if (response.data && response.data != undefined) {
                if (response.data.updateFilterDetail.id) {
                    returnData = {
                        'data': {},
                        'error': false,
                        'notify_msg': "Filter updated successfully."
                    }
                    dispatch(notificationAll(actionTypes.NOTIFICATIONS, returnData, true));                        
                } else {
                    returnData = {
                        'data': {},
                        'error': true,
                        'notify_msg': "Filter data not updated."
                    }
                    dispatch(notificationAll(actionTypes.NOTIFICATIONS, returnData, false));
                }
            }
            dispatch(actionCreators.getFilterList(client,1))
        }).catch((error) => {
            let err_data = errorMessageGraphQl(error);
            dispatch(notificationAll(actionTypes.NOTIFICATIONS, err_data));
        });
    }
}



const setResponseDetails = (newType, data) => {
    return {
        type: newType,
        val: data
    };
}

const notificationAll = (newType, data, status) => {
    return {
        type: newType,
        val: data,
        status: status,
    }
}

const errorMessageGraphQl = (err) => {
    let msg = 'Something Went Wrong!';
    if (err.graphQLErrors && err.graphQLErrors.length > 0) {
        msg = err.graphQLErrors[0].message;
    } else if (err.networkError && err.networkError.result ) {
        msg = err.networkError.result.errors[0].message;
    }else if (err.message) {
        msg = err.message;
    }

    return {
        notify_msg: msg,
        error: true
    }
}

export const clearNotification = (value) => {
    return function (dispatch) {
        dispatch(clearNotificationAll(actionTypes.NOTIFICATIONS, {}, false));
    }
}
const clearNotificationAll = (newType, data, status) => {
    return {
        type: actionTypes.NOTIFICATIONS,
        val: '',
        status: '',
    }
}
